<template lang="html">
  <div>
    <VqModal
      :name="modalName"
      class="vq-modal-add-vm">
      <template v-slot:header>
        <h2 class="modal-title">{{setTitleContext}} <span class="is-bold">{{ $t('components.modalEditVm.vm') }}</span></h2>

        <div class="flex items-center">
          <button
            v-if="context == 'display'"
            @click="edit"
            type="button" class="button is-small is-gamma mr-10">
            {{ $t('components.modalEditVm.config.edit') }}
          </button>
          <button
            v-if="context == 'display'"
            v-on:click="deleteVm"
            class="button is-rounded is-square is-white is-xsmall mr-10">
              <i class="icon-delete is-danger"></i>
          </button>
          <button
            type="button"
            class="button is-square is-rounded is-xsmall is-gray-100 modal-close"
            v-on:click="close">
            <span class="css-icon is-close"></span>
          </button>
        </div>
      </template>
      <template v-slot:content>
        <div class="forms">
          <form>
            <div class="container has-separator">
              <div class="row">
                <VqSelect
                  classes="col-tab-4 pb-10"
                  name="site"
                  :label="$t('components.modalEditVm.form.site')"
                  option-label-attr="vcenter"
                  option-value-attr="vcenter"
                  :placeholder="$t('components.modalEditVm.form.siteP')"
                  :read-only="context=='update' || context=='display'"
                  :options="siteOptions"
                  :tooltip="c('add_vm:site')"
                  :errors="errors.site"
                  v-model="formData.site"
                  @change="onChangeSite"
                />
                <VqInput
                  classes="col-tab-8 pb-10"
                  :label="$t('components.modalEditVm.form.name')"
                  name="name"
                  :tooltip="c('add_vm:vm_name')"
                  type="text"
                  :errors="errors.name"
                  :read-only="context=='display'"
                  v-model="formData.name"
                />
                <VqSelect
                  classes="col-tab-12 pb-10"
                  name="os"
                  :placeholder="$t('components.modalEditVm.form.templateP')"
                  :label="context=='add' ? $t('components.modalEditVm.form.template') : $t('components.modalEditVm.form.os')"
                  :option-label-attr="context=='add' ? 'template_name': 'label'"
                  :option-value-attr="context=='add' ? 'template_name': 'value'"
                  :read-only="context=='update' || context=='display'"
                  :options="context=='add' ? formOsOptions : updateOsOptions"
                  :tooltip="c('add_vm:os')"
                  :errors="errors.os"
                  v-model="formData.os"
                  @change="onChangeOs"
                />
                <VqInput
                  classes="col-tab-3 pb-10"
                  :label="$t('components.modalEditVm.form.vcpu')"
                  name="vcpu"
                  type="number"
                  :tooltip="c('add_vm:cpu')"
                  :min="0"
                  :information="`${$t('components.modalEditVm.form.max')} ${max_vcpu_vm} ${$t('components.modalEditVm.form.vcpu')}`"
                  :errors="errors.vcpu"
                  :read-only="context=='display'"
                  v-model="formData.vcpu"
                />
                <VqInput
                  classes="col-tab-3 pb-10"
                  :label="$t('components.modalEditVm.form.vram')"
                  name="vram"
                  type="number"
                  :tooltip="c('add_vm:vram')"
                  :min="0"
                  :information="`${$t('components.modalEditVm.form.max')} ${max_vram_vm} ${$t('components.modalEditVm.form.gb')}`"
                  :errors="errors.vram"
                  :read-only="context=='display'"
                  v-model="formData.vram"
                />
                <VqToggleBtn
                  v-if="is_cpu_boost"
                  classes="col-tab-3 pb-10"
                  name="cpu_boost"
                  :label="$t('components.modalEditVm.form.boost')"
                  :option-true="$t('components.modalEditVm.form.on')"
                  :option-false="$t('components.modalEditVm.form.off')"
                  v-model="formData.cpu_boost"
                  :tooltip="c('add_vm:cpu_boost')"
                  :disabled="context=='display'"
                  @change="onChangeCpuBoost"
                />
                <VqToggleBtn
                  v-if="hasBackupAccess"
                  classes="col-tab-3"
                  name="backup"
                  :label="$t('components.modalEditVm.form.backup')"
                  :option-true="$t('components.modalEditVm.form.on')"
                  :option-false="$t('components.modalEditVm.form.off')"
                  v-model="formData.is_backup"
                  :tooltip="c('add_vm:backup')"
                  :disabled="context=='display'"
                />
                <VqToggleBtn
                  v-if="is_replicated"
                  classes="col-tab-3"
                  name="protected"
                  :label="$t('components.modalEditVm.form.protected')"
                  :option-true="$t('components.modalEditVm.form.on')"
                  :option-false="$t('components.modalEditVm.form.off')"
                  v-model="formData.protected"
                  :tooltip="c('add_vm:replicated')"
                  :disabled="context=='display'"
                  @change="onChangeProtected"
                />
                <VqSelect
                  v-if="formData.protected"
                  classes="col-tab-6"
                  name="rpo"
                  :placeholder="$t('components.modalEditVm.form.rpo')"
                  label="RPO"
                  option-label-attr="value"
                  option-value-attr="price"
                  :options="user.company_obj.rpo_prices"
                  :read-only="context=='display'"
                  v-model="formData.rpo_price"
                />
              </div>
            </div>
            <div class="container has-separator">
              <div class="row">
                <div class="vq-repeater col-12">
                  <div class="field-wrapper">
                    <button v-if="formData.disks && formData.disks.length < 15 && context!='display'" class="button is-small add-btn mb-10" v-on:click.prevent="addDisk()">{{ $t('components.modalEditVm.addDisk') }}</button>
                    <template v-for="(disk, index) in formData.disks">
                      <div class="repeater-row" :key="index">
                        <h2 class="title-row">{{ $t('components.modalEditVm.disk') }} {{index + 1}}</h2>
                        <div class="repeater-wrapper">
                          <VqInput
                            :label="$t('components.modalEditVm.form.size')"
                            :name="'storage_' + index"
                            :tooltip="c('add_vm:storage_disk')"
                            type="number"
                            :min="minDiskCapacity(disk.old_capacity)"
                            :information="`${$t('components.modalEditVm.form.max')} ${max_storage_disk_vm} ${$t('components.modalEditVm.form.gb')}`"
                            :errors="diskErrors(index, disk)"
                            :read-only="context=='display'"
                            v-model="disk.capacity"
                          />
                          <VqSelect
                            :name="'classe_' + index"
                            :read-only="isReadOnly || context=='display'"
                            :errors="errors.disks[index].classe"
                            :label="$t('components.modalEditVm.form.class')"
                            option-label-attr="label"
                            option-value-attr="value"
                            :options="diskOptions"
                            v-model="disk.classe"
                            :tooltip="c('add_vm:storage_class')"
                          />
                          <div class="delete-row">
                            <span
                              class="icon icon-delete-inverse"
                              v-if="formData.disks.length > 1"
                              v-on:click="removeDisk(index)"
                            ></span>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="context != 'display'" class="container has-separator">
              <div class="row">
                <VqTextarea
                  classes="col-tab-12"
                  :label="$t('components.modalEditVm.form.comment')"
                  name="comment"
                  :tooltip="c('add_vm:comment')"
                  :errors="errors.comment"
                  v-model="formData.comment"
                />
              </div>
            </div>
            <div v-if="newPrice != null" class="container has-separator">
              <h2 class="modal-title is-bold pa-5">{{ $t('components.modalEditVm.pricing') }}</h2>

              <table class="w-full total-table mt-10">
                <thead>
                  <tr class="is-bold">
                    <th>{{ $t('components.modalEditVm.table.resources') }}</th>
                    <th>{{ $t('components.modalEditVm.table.qty') }}</th>
                    <th>{{ $t('components.modalEditVm.table.price') }}</th>
                    <th>{{ $t('components.modalEditVm.table.total') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="user.company_obj.agility_vm_setup_fee && context == 'add'">
                    <td>{{ $t('components.modalEditVm.agility_vm_setup_fee') }} :</td>
                    <td>1</td>
                    <td>{{user.company_obj.agility_vm_setup_fee|price}}€</td>
                    <td>{{ user.company_obj.agility_vm_setup_fee|price}}€</td>
                  </tr>
                  <tr v-if="user.company_obj.backup_setup_fee && formData.is_backup && !currentValues.is_backup" class="nowrap">
                    <td>{{ $t('components.modalEditVm.backup_setup_fee') }} :</td>
                    <td>1</td>
                    <td>{{user.company_obj.backup_setup_fee|price}}€</td>
                    <td>{{ user.company_obj.backup_setup_fee|price}}€</td>
                  </tr>
                  <tr v-if="totalSetupFeeFromApi" class="is-bold">
                    <td class="nowrap">{{ $t('components.modalEditVm.table.totalSetupFee') }} :</td>
                    <td></td>
                    <td></td>
                    <td>{{totalSetupFeeFromApi|price}}€</td>
                  </tr>

                  <tr>
                    <td>{{ $t('components.modalEditVm.vm') }} :</td>
                    <td>1</td>
                    <td>{{user.company_obj.agility_vm_mgmt_price|price}}€</td>
                    <td>{{ user.company_obj.agility_vm_mgmt_price|price}}€</td>
                  </tr>
                  <tr v-if="formData.vcpu">
                    <td>{{ $t('components.modalEditVm.form.vcpu') }} :</td>
                    <td>{{formData.vcpu}}</td>
                    <td>{{user.company_obj.agility_vcpu_price|price}}€</td>
                    <td>{{formData.vcpu * user.company_obj.agility_vcpu_price|price}}€</td>
                  </tr>
                  <tr v-if="formData.vram">
                    <td>{{ $t('components.modalEditVm.form.vram') }} ({{ $t('components.modalEditVm.form.gb') }}) :</td>
                    <td>{{formData.vram}}</td>
                    <td>{{user.company_obj.agility_vram_price|price}}€</td>
                    <td>{{formData.vram * user.company_obj.agility_vram_price|price}}€</td>
                  </tr>
                  <tr v-if="formData.cpu_boost">
                    <td>{{ $t('components.modalEditVm.form.boost') }} :</td>
                    <td>{{formData.vcpu}}</td>
                    <td>{{user.company_obj.agility_cpu_boost_price|price}}€</td>
                    <td>{{formData.vcpu * user.company_obj.agility_cpu_boost_price|price}}€</td>
                  </tr>
                  <tr v-if="formData.protected">
                    <td>{{ $t('components.modalEditVm.form.protected') }} :</td>
                    <td>1</td>
                    <td>{{ agility_protected_price|price}}€</td>
                    <td>{{ agility_protected_price|price}}€</td>
                  </tr>
                  <tr v-if="getClassStorageGb('gold')">
                    <td>{{ $t('components.modalEditVm.table.gold') }} :</td>
                    <td>{{getClassStorageGb('gold')}}</td>
                    <td>{{user.company_obj.agility_gold_storage_price|price}}€</td>
                    <td>{{getClassStorageGb('gold') * user.company_obj.agility_gold_storage_price|price}}€</td>
                  </tr>
                  <tr v-if="getClassStorageGb('silver')">
                    <td>{{ $t('components.modalEditVm.table.silver') }} :</td>
                    <td>{{getClassStorageGb('silver')}}</td>
                    <td>{{user.company_obj.agility_silver_storage_price|price}}€</td>
                    <td>{{getClassStorageGb('silver') * user.company_obj.agility_silver_storage_price|price}}€</td>
                  </tr>
                  <tr v-if="getClassStorageGb('bronze')">
                    <td>{{ $t('components.modalEditVm.table.bronze') }} :</td>
                    <td>{{getClassStorageGb('bronze')}}</td>
                    <td>{{user.company_obj.agility_bronze_storage_price|price}}€</td>
                    <td>{{getClassStorageGb('bronze') * user.company_obj.agility_bronze_storage_price|price}}€</td>
                  </tr>
                  <tr v-if="user.company_obj.backup_recurring_price && formData.is_backup && getTotalStorage()">
                    <td>{{ $t('components.modalEditVm.table.maxBackupPrice') }} :</td>
                    <td>{{getTotalStorage()}}</td>
                    <td>{{user.company_obj.backup_recurring_price|price}}€</td>
                    <td>{{getTotalStorage() * user.company_obj.backup_recurring_price|price}}€</td>
                  </tr>
                  <tr v-if="newPrice != null" class="is-bold">
                    <td>{{ $t('components.modalEditVm.table.totalMonthlyPrice') }} :</td>
                    <td></td>
                    <td></td>
                    <td>
                      <span v-if="priceLoadingVisible">...</span>
                      <template v-else>
                        {{newPrice|price}}€
                        <div class="mt-5" v-if="context === 'update'">
                          (<span v-if="(newPrice - oldPrice) >= 0">+</span>
                          {{(newPrice - oldPrice)|price}}€ )
                        </div>
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </form>
          <p v-for="(error, index) in errors.non_field_errors" :key="index" class="mt-10 is-center-aligned is-danger">{{error}}</p>
        </div>
      </template>
      <template v-slot:footer>
        <button type="button" class="button is-small is-gray-400" v-on:click="close">{{ $t('components.modalEditVm.form.cancel') }}</button>
        <div>
          <button
            v-if="$store.state.display_edit && $store.state.otrs_is_active && user && user.is_admin && context != 'display'"
            :class="{'is-loading': loading, 'is-disabled': disableButton}"
            type="button" class="button is-small is-gamma"
            @click="submit">
            {{setTitleContext}}
          </button>
        </div>
      </template>
    </VqModal>
    <ModalVerificationCode
      v-if="isModalVerificationOpen"
      @verification-code="setVerification"
      @close-verification="closeVerification"/>
  </div>
</template>

<script lang="js">
import { mapGetters } from 'vuex';
import { eventHubMixin } from '@/mixins/event';

import VSPHERE from '@/api/vsphere';
import SUPPORT from '@/api/support';

import VqModal from '@/components/VqModal.vue';
import VqInput from '@/components/VqInput.vue';
import VqSelect from '@/components/VqSelect.vue';
import VqTextarea from '@/components/VqTextarea.vue';
import VqToggleBtn from '@/components/VqToggleBtn.vue';

import ModalVerificationCode from '@/components/ModalVerificationCode.vue';

export default {
  name: 'ModalAddEditVm',
  mixins: [eventHubMixin],
  components: {
    VqModal,
    VqInput,
    VqSelect,
    VqTextarea,
    VqToggleBtn,
    ModalVerificationCode,
  },
  props: [],

  data() {
    return {
      modalName: 'add-edit-vm',
      formData: {
        site: '',
        os: '',
      },
      errors: {},
      context: 'add',
      max_storage_disk_vm: null,
      max_vcpu_vm: null,
      max_vram_vm: null,
      osOptions: [],
      formOsOptions: [],
      siteOptions: [],
      updateOsOptions: [],
      diskOptions: [{
        label: this.$t('components.modalEditVm.config.diskOptions.gold'),
        value: 'gold',
      },
      {
        label: this.$t('components.modalEditVm.config.diskOptions.silver'),
        value: 'silver',
      },
      ],
      toasterDetails: {
      },
      is_replicated: true,
      is_cpu_boost: true,
      newPrice: null,
      oldPrice: 0,
      totalSetupFeeFromApi: 0,
      priceLoading: false,
      priceLoadingVisible: false,
      priceFetchTimeout: null,
      priceLoadingDelayTimeout: null,
      currentValues: {},
      isModalVerificationOpen: false,
      loading: false,
      isDisabled: false,
    };
  },
  filters: {
    price(value) {
      return (value / 100).toFixed(2);
    },
  },
  watch: {
    formData: {
      handler() {
        if (this.context === 'display') return;
        if (this.priceFetchTimeout) clearTimeout(this.priceFetchTimeout);
        this.priceFetchTimeout = setTimeout(() => this.fetchPrice(), 300);
      },
      deep: true,
    },
  },
  mounted() {
    this.onOpenModal(this.modalName, (data) => {
      VSPHERE.listOs().then((res) => {
        this.siteOptions = [...new Map(res.data.map(item => [item.vcenter, item])).values()];
        this.osOptions = res.data.sort((a, b) => ((a.template_name > b.template_name) ? 1 : ((b.template_name > a.template_name) ? -1 : 0)));
        this.formOsOptions = [...new Map(this.osOptions.map(item => [item.template_name, item])).values()];
        this.getMaxValues();
        this.initFormData();
        this.initFormErrors();
        this.dataToForm(data);
        if (!data || Object.keys(data).length === 0) {
          this.fetchPrice();
        }
      });
    });
  },
  methods: {

    diskErrors(index, disk) {
      if (this.context !== 'add') {
        if (disk.capacity < disk.old_capacity) {
          return ['Warning: Disk size should not be reduced !'];
        }
      }
      if (this.errors.disks[index] && this.errors.disks[index].capacity) {
        return this.errors.disks[index].capacity;
      }
      return [];
    },
    close() {
      this.emitCloseModal(this.modalName);
    },

    edit() {
      this.context = 'update';
      this.fetchPrice();
    },

    deleteVm() {
      this.formData.price = this.newPrice;
      this.emitOpenModal('delete-vm', this.formData);
      this.emitCloseModal(this.modalName);
    },

    initFormData() {
      this.newPrice = null;
      this.oldPrice = 0;
      this.totalSetupFeeFromApi = 0;
      this.formData = {
        name: '',
        os: '',
        vcpu: '',
        vram: '',
        site: '',
        cpu_boost: false,
        protected: false,
        is_backup: false,
        disks: [
          {
            capacity: 0,
            old_capacity: 0,
            classe: 'gold',
          },
        ],
        comment: '',
        verification_code: '',
        rpo_price: 0,
      };
    },

    initFormErrors() {
      this.errors = {
        name: [],
        vcpu: [],
        vram: [],
        comment: [],
        site: [],
        os: [],
        disks: [
          {
            capacity: [],
          },
        ],
        verification_code: [],
        non_field_errors: [],
        rpo_price: [],
      };
    },

    resetFormErrors() {
      this.errors.name = [];
      this.errors.vcpu = [];
      this.errors.vram = [];
      this.errors.comment = [];
      this.errors.site = [];
      this.errors.os = [];
      this.errors.verification_code = [];
      this.errors.non_field_errors = [];
      this.errors.rpo_price = [];
      this.errors.disks.forEach((disk, index) => {
        disk.capacity = [];
      });
    },

    getMaxValues() {
      SUPPORT.maxValues().then((res) => {
        this.max_storage_disk_vm = res.data.max_storage_disk_vm;
        this.max_vcpu_vm = res.data.max_vcpu_vm;
        this.max_vram_vm = res.data.max_vram_vm;
      });
    },

    fetchPrice() {
      if (!this.user || !this.user.company_obj) return;
      const disks = (this.formData.disks || []).map(d => ({
        capacity: parseInt(d.capacity, 10) || 0,
        classe: d.classe || 'gold',
      }));
      const payload = {
        context: this.context === 'add' ? 'add' : 'edit',
        vcpu: parseInt(this.formData.vcpu, 10) || 0,
        vram: parseInt(this.formData.vram, 10) || 0,
        cpu_boost: !!this.formData.cpu_boost,
        protected: !!this.formData.protected,
        is_backup: !!this.formData.is_backup,
        disks,
        rpo_price: parseInt(this.formData.rpo_price, 10) || 0,
      };
      if (this.context === 'update' || this.context === 'display') {
        payload.current_vcpu = parseInt(this.currentValues.vcpu, 10) || 0;
        payload.current_vram = parseInt(this.currentValues.vram, 10) || 0;
        payload.current_cpu_boost = !!this.currentValues.cpu_boost;
        payload.current_protected = !!this.currentValues.protected;
        payload.current_is_backup = !!this.currentValues.is_backup;
        payload.current_rpo_price = 0;
        const currentDisks = this.currentValues.disks || [];
        const rpoPrices = this.user.company_obj && this.user.company_obj.rpo_prices;
        const rpoMatch = rpoPrices ? rpoPrices.find(r => r.value === this.currentValues.rpo) : undefined;
        if (rpoMatch) payload.current_rpo_price = rpoMatch.price;
        payload.current_disks = currentDisks.map(d => ({
          capacity: parseInt(d.capacity, 10) || 0,
          classe: d.classe || 'gold',
        }));
      }
      if (this.priceLoadingDelayTimeout) clearTimeout(this.priceLoadingDelayTimeout);
      this.priceLoadingVisible = false;
      this.priceLoading = true;
      this.priceLoadingDelayTimeout = setTimeout(() => {
        this.priceLoadingVisible = true;
      }, 200);
      VSPHERE.calculateVmPrice(payload)
        .then((res) => {
          this.newPrice = res.data.new_price;
          this.oldPrice = res.data.old_price;
          this.totalSetupFeeFromApi = res.data.total_setup_fee;
        })
        .catch(() => {
          this.newPrice = null;
          this.oldPrice = 0;
          this.totalSetupFeeFromApi = 0;
        })
        .finally(() => {
          if (this.priceLoadingDelayTimeout) {
            clearTimeout(this.priceLoadingDelayTimeout);
            this.priceLoadingDelayTimeout = null;
          }
          this.priceLoading = false;
          this.priceLoadingVisible = false;
        });
    },

    addDisk() {
      let diskClass;
      if (this.formData.disks.length === 0) {
        diskClass = this.diskOptions[0].value;
      } else {
        diskClass = this.formData.disks[0].classe;
      }
      this.errors.disks.push({
        capacity: [],
      });
      this.formData.disks.push({
        name: 'New disk',
        capacity: 0,
        classe: diskClass,
      });
    },

    removeDisk(i) {
      this.formData.disks.splice(i, 1);
    },

    setVerification(data) {
      this.isModalVerificationOpen = false;
      this.formData.verification_code = data;
      this.submit();
    },
    sendVerificationCode() {
      this.loading = true;
      SUPPORT.verification_code().then((res) => {
        this.isModalVerificationOpen = true;
      }),
      (err) => {
        Object.assign(this.errors, err.response.data);
      };
    },

    noUpdate() {
      if (this.formData.current_name === this.formData.name
        && this.formData.current_vcpu === this.formData.vcpu
        && this.formData.current_vram === this.formData.vram
        && JSON.stringify(this.formData.current_disks) === JSON.stringify(this.formData.disks)
        && this.formData.current_protected === this.formData.protected
        && this.formData.current_is_backup === this.formData.is_backup
        && this.formData.current_cpu_boost === this.formData.cpu_boost) {
        return true;
      }
      return false;
    },

    submit() {
      // Prix calculés côté serveur - ne plus envoyer price/current_price/total_setup_fee
      this.formData.current_name = this.currentValues.name;
      this.formData.current_vcpu = this.currentValues.vcpu;
      this.formData.current_vram = this.currentValues.vram;
      this.formData.current_disks = this.currentValues.disks;
      this.formData.current_protected = this.currentValues.protected;
      this.formData.current_is_backup = this.currentValues.is_backup;
      this.formData.current_cpu_boost = this.currentValues.cpu_boost;
      const rpoPrices = this.user.company_obj && this.user.company_obj.rpo_prices;
      const rpoMatch = rpoPrices ? rpoPrices.find(r => r.value === this.currentValues.rpo) : undefined;
      this.formData.current_rpo_price = rpoMatch ? rpoMatch.price : 0;

      const method = this.context === 'add' ? 'addVm' : 'editVm';
      if (method === 'editVm' && this.noUpdate()) {
        this.close();
      } else {
        this.resetFormErrors();
        VSPHERE[method](this.formData).then((res) => {
          this.submitActions();
          this.loading = false;
        }).catch((err) => {
          Object.assign(this.errors, err.response.data);
          this.formData.verification_code = '';
          if (Object.keys(err.response.data).toString() === ['verification_code'].toString()) {
            this.sendVerificationCode();
          }
          if (err.response.status === 500) {
            this.emitAddToaster({
              title: this.$t('components.modalEditVm.toasts.ticketError'),
              text: this.$t('components.modalEditVm.toasts.ticketErrorContent'),
              state: 'danger',
            });
            this.close();
          }
        });
      }
    },


    submitActions() {
      this.initFormData();
      this.initFormErrors();
      this.close();
      this.emitToaster();
    },

    dataToForm(data) {
      if (data && Object.keys(data).length !== 0) {
        this.$nextTick(() => {
          this.formData = JSON.parse(JSON.stringify(data));
          this.currentValues = JSON.parse(JSON.stringify(data));
          if (this.formData.rpo) {
            const rpo = this.user.company_obj.rpo_prices.find(r => r.value == this.formData.rpo);
            this.$set(this.formData, 'rpo_price', rpo.price);
          }
          this.formData.disks.forEach((element) => {
            element.old_capacity = element.capacity;
            this.errors.disks.push({
              capacity: [],
            });
          });
          this.fetchPrice();
        });
        this.updateOsOptions = [{ label: data.os, value: data.os }];
        this.context = 'display';
      } else {
        this.context = 'add';
      }
    },

    emitToaster() {
      this.emitAddToaster({
        title: this.$t('components.modalEditVm.toasts.ticketCreate'),
        text: `${this.$t('components.modalEditVm.toasts.ticketVm')} ${this.context === 'add' ? this.$t('components.modalEditVm.toasts.added') : this.$t('components.modalEditVm.toasts.updated')} ${this.$t('components.modalEditVm.toasts.ticketCreateContent')}`,
        state: 'success',
      });
    },

    onChangeSite(val) {
      this.formData.os = '';
      this.formOsOptions = this.osOptions.filter(option => option.vcenter === val);
      const site = this.siteOptions.find(site => site.vcenter === val);
      this.formData.os = this.formOsOptions.find(option => option.vcenter === val).template_name;
      this.formData.os_name = this.formOsOptions.find(option => option.vcenter === val).value;


      if (site.is_replicated) {
        this.is_replicated = true;
      } else {
        this.is_replicated = false;
        this.formData.protected = false;
      }

      if (site.is_cpu_boost) {
        this.is_cpu_boost = true;
      } else {
        this.is_cpu_boost = false;
        this.formData.cpu_boost = false;
      }
    },
    onChangeOs(value) {
      this.osOptions.forEach((os) => {
        if (value === os.template_name) {
          this.formData.os_name = os.label;
        }
        if (value === os.label) {
          this.formData.disks.forEach((disk) => {
            if (disk.capacity < os.storage) {
              disk.capacity = os.storage;
            }
          });
        }
      });
    },
    onChangeCpuBoost(value) {
      this.formData.protected = value ? false : value;
    },
    onChangeProtected(value) {
      this.formData.cpu_boost = value ? false : value;
      if (this.context == 'add') {
        this.formData.rpo_price = this.user.company_obj.rpo_prices[0].price;
      }
    },

    getTotalStorage() {
      let total = 0;
      if (this.formData.disks) {
        this.formData.disks.forEach((disk) => {
          total += parseInt(disk.capacity);
        });
      }
      return total;
    },

    getClassStorageGb(classe) {
      if (this.formData.disks) {
        const sumOfGb = this.formData.disks.filter(disk => disk.classe === classe).reduce((sum, currentValue) => sum + parseInt(currentValue.capacity), null);

        if (sumOfGb) {
          return sumOfGb;
        }
        return 0;
      }
    },
    closeVerification() {
      this.isModalVerificationOpen = false;
      this.loading = false;
    },

    minDiskCapacity(capacity) {
      if (this.context === 'add') {
        return 0;
      }
      return parseInt(capacity);
    },
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      hasBackupAccess: 'auth/hasBackupAccess',

    }),
    isReadOnly() {
      return true ? this.formData.disks.length > 1 : false;
    },
    setTitleContext() {
      if (this.context === 'add') {
        return this.$t('components.modalEditVm.config.add');
      } if (this.context == 'display') {
        return this.$t('components.modalEditVm.config.details');
      }
      return this.$t('components.modalEditVm.config.submit');
    },

    agility_protected_price() {
      const rpoPct = (this.formData.protected && this.formData.rpo_price)
        ? this.formData.rpo_price : 0;
      const cpuBoostPrice = this.formData.cpu_boost
        ? this.user.company_obj.agility_cpu_boost_price * (parseInt(this.formData.vcpu, 10) || 0) : 0;
      if (!rpoPct || this.newPrice == null) return 0;
      return this.newPrice - (
        (this.newPrice - cpuBoostPrice) / (1 + rpoPct / 100)
      );
    },
    disableButton() {
      if (this.formData.disks) {
        return this.formData.disks.find(
          disk => disk.capacity < this.minDiskCapacity(disk.old_capacity),
        );
      }
      return false;
    },
  },
};
</script>

<style scoped lang="scss">

.total-table {
  th {
    text-align: left;
  }
  td, th {
    padding: 5px;
  }
}
</style>
